var _style, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 79",
    style: {
      enableBackground: "new 0 0 79 79"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000031923199959894337990000008527518606417832857_);}\n\t.st1{fill:#BFBFBF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 79,
    height: 79
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000004547660533685310570000013746365268030244498_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000004547660533685310570000013746365268030244498_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.5,1c-0.4,0-0.8,0.1-1.2,0.2L5.6,15.1c-3.3,0.9-5.2,4.3-4.4,7.6L3,29.3c0.2,0.7,0.7,1.3,1.5,1.5 c0.7,0.2,1.5,0,2-0.5C7,29.7,7.2,29,7,28.3l-1.8-6.7c-0.3-1.1,0.3-2.2,1.5-2.5L58.3,5.2c1.1-0.3,2.2,0.3,2.5,1.5L63.6,17 c0.2,0.7,0.7,1.3,1.5,1.5c0.7,0.2,1.5,0,2-0.5c0.5-0.5,0.7-1.3,0.5-2L64.8,5.6C64.1,2.7,61.4,0.8,58.5,1z M14.4,20.7 c-3.4,0-6.2,2.8-6.2,6.2v34.5c-0.1,0.4-0.1,0.8,0,1.2v3.5c0,1.7,0.7,3.3,1.9,4.4l29-22.9l-4.9-3.8c-0.4-0.3-0.9-0.4-1.4-0.4 c-0.4,0-0.8,0.1-1.1,0.4L12.4,57.9v-31c0-1.2,0.9-2.1,2.1-2.1H68c0,0,0,0,0,0l3.6-2.9c-1-0.8-2.3-1.3-3.7-1.3L14.4,20.7L14.4,20.7 z M77.2,20.7c-0.5,0-0.9,0.2-1.3,0.5L8,74.8c-0.6,0.4-1,1.2-0.9,2c0.1,0.8,0.6,1.4,1.3,1.7s1.5,0.1,2.1-0.4l67.9-53.6 c0.7-0.5,1-1.5,0.7-2.3C78.9,21.2,78.1,20.7,77.2,20.7z M20.6,28.9c-2.3,0-4.1,1.8-4.1,4.1c0,1.1,0.4,2.1,1.2,2.9 c0.8,0.8,1.8,1.2,2.9,1.2c1.1,0,2.1-0.4,2.9-1.2c0.8-0.8,1.2-1.8,1.2-2.9C24.7,30.8,22.9,28.9,20.6,28.9z M74.1,30.5L70,33.7v22.1 l-11.2-8c-0.3-0.2-0.7-0.4-1.2-0.4c-0.5,0-0.9,0.1-1.3,0.4c-2.8,2.2-7,5.2-8.6,6.5l-2.1-1.6L21.2,72.3H68c3.4,0,6.2-2.8,6.2-6.2 v-5.4c0.2-0.4,0.2-0.9,0-1.4V30.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductImagePlaceholder);
export default __webpack_public_path__ + "static/media/product_image_placeholder.b0eeb34b8968172adb4dfe14ba0d1261.svg";
export { ForwardRef as ReactComponent };